import React, { useState, useEffect } from 'react';
import { notification } from 'antd';
import axios from 'axios';

import { API_URL, ENDPOINTS } from '../constants/api';
import '../css/modal.css';
import { useTranslation } from 'react-i18next';

const DetailData = ({ token, route, title, id, isOpen, onRequestClose }) => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const { t } = useTranslation();

  useEffect(() => {
    try {
      setLoading(true);
      const url = `${API_URL}/${ENDPOINTS.SYS}/${route}/${id}`;
      // console.log('url:', url);
      axios
        .get(url, {
          headers: {
            Authorization: token ? `Bearer ${token}` : '',
          },
        }) // Replace with your API
        .then((response) => {
          // console.log('url:', url, 'response:', response.data);

          if (response.data.success === 0) {
            notification.error({ message: response.data.message });
          } else {
            setData(response.data);
          }
          setLoading(false);
        })
        .catch((error) => {
          console.error('Error fetching data:', error.message);
          setLoading(false);
        });
    } catch (err) {
      console.log('err:', err.message);
    }
  }, []);

  // Get column headers dynamically
  const headers = data?.length > 0 ? Object.keys(data[0]) : [];

  //  console.log('headers:', headers);

  return (
    <div
      className={`modal fade ${isOpen ? 'show' : ''}`}
      style={{ display: isOpen ? 'block' : 'none' }}
      tabIndex="-1"
      aria-hidden={isOpen ? 'false' : 'true'}
    >
      <div className="modal-dialog modal-xl">
        <div className="modal-content  ">
          <div className="modal-header bg-primary text-white">
            <h5 className="modal-title">{title}</h5>
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
              onClick={onRequestClose}
            ></button>
          </div>
          <div className="modal-body  table-responsive">
            {data && data.length > 0 ? (
              <div className="table-responsive">
                <table className="table table-bordered">
                  <thead className="thead-dark">
                    <tr>
                      {headers.map((header) => (
                        <th key={header}>{t(header.toUpperCase())}</th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {data.map((item, index) => (
                      <tr key={index}>
                        {headers.map((key) => (
                          <td key={key}>
                            {String(item[key]).includes('<') &&
                            String(item[key]).includes('/>')
                              ? ''
                              : item[key]}
                          </td>
                        ))}
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            ) : loading ? (
              <p>{t('Loading')}...</p>
            ) : (
              <p>{t('No data available')}.</p>
            )}

            <button
              type="button"
              className="btn btn-secondary ms-2"
              onClick={onRequestClose}
            >
              Close
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DetailData;
